import React from "react";

import { useUi } from "@jelly/lesson";
import { Modal } from "@jelly/ui";
import { useIntl } from "react-intl";

import { messages } from "../Case1TechnicalPov.messages";
import { nl2p } from "@src/utils/nl2p";

type VenueModalProps = Omit<React.ComponentProps<typeof Modal>, "children">;

import styles from "./VenueModal.module.scss";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import { PhotoView } from "@src/lms/jelly/extensions/layouts/photo-view/PhotoView";
import * as appConfig from "appConfig";

const VENUE_360_URL = "https://laznianowa.wkraj.pl/html5/index.php?id=85468#85468/267,4";

export const VenueModal: React.FC<VenueModalProps> = (props) => {
  const ui = useUi();
  const { formatMessage } = useIntl();

  return (
    <ui.Modal {...props} title={formatMessage(messages.modalVenueTitle)} className={styles.modal}>
      <div className={styles.content}>
        <div>
          <div>
            <ui.Scrollbars autoHeight autoHeightMax={"70vh"}>
              {nl2p(formatMessage(messages.modalVenueDescription))}
            </ui.Scrollbars>
            <ui.Button shape={"normal"} theme={"primary"} size={"small"} onClick={() => window.open(VENUE_360_URL)}>
              {formatMessage(messages.view360)}
            </ui.Button>
          </div>
        </div>
        <div className={styles.gallery}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/*/}
          <SpatialCarousel controlsPosition={"bottom"}>
            {["1.jpg", "2.jpg"].map((src) => (
              <PhotoView
                key={src}
                imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case-example/technical-pov/venue/${src}`}
                description={formatMessage(messages.modalVenuePhotoAuthor)}
                imgMode={"cover"}
              />
            ))}
          </SpatialCarousel>
        </div>
      </div>
    </ui.Modal>
  );
};

//TODO : list all ts-expect-error for further analysis
